// src/services/storageService.js
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../firebase/config";

export const uploadFile = async (file, path) => {
  try {
    const storageRef = ref(storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return {
      url: downloadURL,
      path: snapshot.ref.fullPath
    };
  } catch (error) {
    console.error("File upload error:", error);
    throw error;
  }
};

export const uploadProfileImage = async (userId, file) => {
    try {
      const fileExtension = file.name.split('.').pop();
      const fileName = `${Date.now()}.${fileExtension}`;
      const path = `profile-images/${userId}/${fileName}`;  // Notice the path structure change
      return await uploadFile(file, path);
    } catch (error) {
      console.error("Profile image upload error:", error);
      throw error;
    }
  };
  
export const uploadPostImage = async (userId, file) => {
    try {
      const fileExtension = file.name.split('.').pop();
      const fileName = `${Date.now()}.${fileExtension}`;
      const path = `post-images/${userId}/${fileName}`;  // Notice the path structure change
      return await uploadFile(file, path);
    } catch (error) {
      console.error("Post image upload error:", error);
      throw error;
    }
  };

export const deleteFile = async (path) => {
  try {
    const fileRef = ref(storage, path);
    await deleteObject(fileRef);
    return { success: true };
  } catch (error) {
    console.error("File deletion error:", error);
    throw error;
  }
};